import { render, staticRenderFns } from "./TableAnggota.vue?vue&type=template&id=36fb70a9&"
import script from "./TableAnggota.vue?vue&type=script&lang=js&"
export * from "./TableAnggota.vue?vue&type=script&lang=js&"
import style0 from "./TableAnggota.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports